import { LoadingSpinner, TicketTable } from '@components';
import React, { FC, useState } from 'react';

export const UserTickets: FC = ({ tickets }) => {
  const [loading, setLoading] = useState(false);

  return (
    <div className="h-full">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <TicketTable tickets={tickets.slice(0, 5)} />
      )}
    </div>
  );
};

export default UserTickets;
